import HubSectionsList from './HubSectionsList'

export default HubSectionsList
